/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgListNumberBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.24199 5.99212H20.242M8.24199 11.9951H20.24M8.23999 17.9941H20.24M4.11699 7.49512V3.74512H2.98999M2.98999 7.49512H4.11499H5.23999M3.31999 10.0721C3.42342 9.96336 3.54756 9.87639 3.68511 9.81634C3.82266 9.75629 3.97084 9.72437 4.12091 9.72246C4.27099 9.72055 4.41993 9.74869 4.55896 9.80522C4.698 9.86175 4.82431 9.94553 4.93047 10.0516C5.03664 10.1577 5.12049 10.284 5.17711 10.423C5.23373 10.562 5.26196 10.7109 5.26015 10.861C5.25833 11.0111 5.2265 11.1592 5.16654 11.2968C5.10658 11.4344 5.01969 11.5586 4.91099 11.6621L3.08099 13.4921H5.24099M2.98999 15.7451H4.11499C4.41336 15.7451 4.69951 15.8636 4.91049 16.0746C5.12146 16.2856 5.23999 16.5717 5.23999 16.8701C5.23999 17.1685 5.12146 17.4546 4.91049 17.6656C4.69951 17.8766 4.41336 17.9951 4.11499 17.9951H3.73999M3.73999 17.9931H4.11499C4.41336 17.9931 4.69951 18.1116 4.91049 18.3226C5.12146 18.5336 5.23999 18.8197 5.23999 19.1181C5.23999 19.4165 5.12146 19.7026 4.91049 19.9136C4.69951 20.1246 4.41336 20.2431 4.11499 20.2431H2.98999"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgListNumber = wrapIcon(SvgListNumberBase);
export default SvgListNumber;
